<template>
  <v-card outlined light class="rounded-md">
    <v-container style="background-color: #45e09e">
      <v-row>
        <v-col cols="auto" class="pa-6" align-self="center">
          <v-card-title
            primary-title
            style="text-align: left"
            class="pa-0"
            color="white"
          >
            <span
              style="
                font-family: Inter;
                color: white;
                font-size: 18px;
                line-height: 18px;
              "
            >
              <v-icon small color="white" style="margin-top: -3px"
                >mdi-key</v-icon
              >
              Finalizer Keys
            </span>
          </v-card-title>
        </v-col>
      </v-row>
    </v-container>
    <v-col class="pa-6 py-3">
      <v-list v-if="registeredKeysArray.length > 0" dense>
        <v-list-item
          v-for="key in registeredKeysArray"
          :key="key.binary"
          class="d-flex align-center pa-0"
          style="min-height: 24px"
        >
          <v-list-item-icon
            class="my-0"
            style="
              min-width: 16px;
              margin-right: 4px;
              display: flex;
              align-items: center;
            "
          >
            <v-icon
              v-if="key.binary === activeFinalizerKeyBinary"
              small
              color="black"
              >mdi-circle</v-icon
            >
          </v-list-item-icon>
          <v-list-item-content class="py-0">
            <v-list-item-title
              :style="
                key.binary === activeFinalizerKeyBinary
                  ? currentKeyStyle
                  : otherKeyStyle
              "
            >
              {{ truncateKey(key.normal) }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <div
        v-else
        class="my-2"
        style="font-family: Inter; font-size: 0.875rem; font-weight: 400"
      >
        Waiting to receive data
      </div>
    </v-col>
  </v-card>
</template>

<script>
export default {
  props: {
    node: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    registeredKeys() {
      const keysValue =
        this.$store.state.metrics.metric[
          this.getMetricId('Producer', 'RegisteredFinalizerSigningKeys')
        ];
      if (keysValue) {
        try {
          const keysMap = JSON.parse(keysValue);
          return Object.entries(keysMap).map(([binary, normal]) => ({
            binary,
            normal,
          }));
        } catch (e) {
          return [];
        }
      } else {
        return [];
      }
    },
    registeredKeysArray() {
      return [...this.registeredKeys].sort((a, b) =>
        a.normal.localeCompare(b.normal)
      );
    },
    activeFinalizerKeyBinary() {
      return this.$store.state.metrics.metric[
        this.getMetricId('Producer', 'ActiveFinalizerSigningKey')
      ];
    },
    currentKeyStyle() {
      return {
        fontFamily: 'Inter',
        fontSize: '0.875rem',
        fontWeight: '600',
        marginRight: '4px',
      };
    },
    otherKeyStyle() {
      return {
        fontFamily: 'Inter',
        fontSize: '0.875rem',
        fontWeight: '400',
      };
    },
    indexStyle() {
      return {
        fontFamily: 'Inter',
        fontSize: '10px',
        lineHeight: '10px',
        fontWeight: '400',
        verticalAlign: 'middle',
        color: '#a0a0a0',
        width: '16px',
        textAlign: 'center',
      };
    },
  },
  methods: {
    getMetricId(module, name) {
      const alert = this.node.alerts.find(
        (alert) => alert.metric === `${module}/${name}`
      );
      return alert ? alert.id : null;
    },
    truncateKey(key) {
      if (key.length <= 36) return key;
      return `${key.slice(0, 18)}...${key.slice(-18)}`;
    },
  },
};
</script>
